<template>
    <prime-button
        :label="closeLabel ?? t('ok')"
        class="p-button-outlined"
        @click="emit('close')"
    />
</template>

<script setup lang="ts">
import PrimeButton from 'primevue/button'
import { useI18n } from 'vue-i18n'

defineOptions({
    name: 'AppAlertFooter'
})

const emit = defineEmits<{
    (e: 'close'): void
}>()

type AppAlertFooterProps = {
    // Alert callers can replace the generic OK action when the next step is more specific.
    closeLabel?: string
}

withDefaults(defineProps<AppAlertFooterProps>(), {
    closeLabel: undefined
})

const { t } = useI18n({ useScope: 'global' })
</script>
